import React from 'react'
import Breakfast from './MealTypes/Breakfast'
import Lunch from './MealTypes/Lunch'
import Dinner from './MealTypes/Dinner'
import Snacks from './MealTypes/Snacks'

const Meals = ({
  dateSearchInput,
  datetimeEntry,
  dayOfWeek,
  mealEntries,
  foods,
  meals,
  units,
  chooseDeleteMealEntryId,
  homemadeFoods,
  ingredients,
  submitted,
  setSubmitted,
  currentUserId,
}) => {
  return (
    <div style={{ width: '90%', margin: '5px 5%' }}>
      <Breakfast
        foods={foods}
        meals={meals}
        homemadeFoods={homemadeFoods}
        mealEntries={mealEntries}
        units={units}
        dateSearchInput={dateSearchInput}
        dayOfWeek={dayOfWeek}
        chooseDeleteMealEntryId={chooseDeleteMealEntryId}
        submitted={submitted}
        setSubmitted={setSubmitted}
        currentUserId={currentUserId}
        ingredients={ingredients}
      />
      <Lunch
        foods={foods}
        meals={meals}
        homemadeFoods={homemadeFoods}
        mealEntries={mealEntries}
        units={units}
        dateSearchInput={dateSearchInput}
        dayOfWeek={dayOfWeek}
        chooseDeleteMealEntryId={chooseDeleteMealEntryId}
        submitted={submitted}
        setSubmitted={setSubmitted}
        currentUserId={currentUserId}
        ingredients={ingredients}
      />
      <Dinner
        foods={foods}
        meals={meals}
        homemadeFoods={homemadeFoods}
        mealEntries={mealEntries}
        units={units}
        dateSearchInput={dateSearchInput}
        datetimeEntry={datetimeEntry}
        dayOfWeek={dayOfWeek}
        chooseDeleteMealEntryId={chooseDeleteMealEntryId}
        submitted={submitted}
        setSubmitted={setSubmitted}
        currentUserId={currentUserId}
        ingredients={ingredients}
      />
      <Snacks
        foods={foods}
        meals={meals}
        homemadeFoods={homemadeFoods}
        mealEntries={mealEntries}
        units={units}
        dateSearchInput={dateSearchInput}
        dayOfWeek={dayOfWeek}
        chooseDeleteMealEntryId={chooseDeleteMealEntryId}
        submitted={submitted}
        setSubmitted={setSubmitted}
        currentUserId={currentUserId}
        ingredients={ingredients}
      />
    </div>
  )
}

export default Meals
